import { ChartData } from "./types";
import DataBarChart from "./DataBarChart";
import DataLineChart from "./DataLineChart";
import DataPieChart from "./DataPieChart";
import DataTable from "./DataTable";
import KPICard from "./KPICard";

interface ChartRendererProps {
  data: ChartData;
}

export default function ChartRenderer({ data }: ChartRendererProps) {
  switch (data.chartType) {
    case "bar":
      return <DataBarChart data={data} />;
    case "line":
      return <DataLineChart data={data} />;
    case "pie":
      return <DataPieChart data={data} />;
    case "table":
      return <DataTable data={data} />;
    case "kpi":
      return <KPICard data={data} />;
    default:
      return <DataTable data={data} />;
  }
}
